<div *ngIf="filiais.length > 0" class="flex flex-col mt-10">
  <div class="overflow-x-auto">
    <div class="inline-block min-w-full py-2 overflow-x-auto overflow-y-auto align-middle">
      <div class="overflow-hidden">
        <table class="min-w-full">
          <thead class="border-b border-gray-400">
            <tr>
              <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Status
              </th>
              <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Nome
              </th>
              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Código
              </th>
              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                CNPJ
              </th>

              <th
                scope="col"
                class="px-6 py-3 font-bold tracking-wider text-center uppercase text-chathams-blue"
                *isAllowed="[ERoleAdminString.Admin, 'subsidiary.update']"
              >
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-white hover:bg-iceberg" *ngFor="let filial of filiais">
              <td class="px-6 py-4 pl-0 font-medium text-md text-chathams-blue whitespace-nowrap">
                <app-status-switch
                  [active]="filial.active"
                  [itemName]="'filial ' + filial.name"
                  [enablePermissions]="[ERoleAdminString.Admin, 'subsidiary.enable']"
                  [disablePermissions]="[ERoleAdminString.Admin, 'subsidiary.disable']"
                  (toggle)="toogleEmpresaStatus(filial.id!, filial.active)"
                ></app-status-switch>
              </td>
              <td class="px-6 py-4 pl-0 font-medium text-md text-chathams-blue whitespace-nowrap">
                {{ filial.name }}
              </td>
              <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ filial.code }}
              </td>
              <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ filial.document | mask: '00.000.000/0000-00' }}
              </td>

              <td
                class="flex justify-center flex-1 gap-2 px-6 py-4 whitespace-normal text-md text-chathams-blue"
                *isAllowed="[ERoleAdminString.Admin, 'subsidiary.update']"
              >
                <button
                  *isAllowed="[ERoleAdminString.Admin, 'subsidiary.update']"
                  class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                  type="button"
                  [attr.aria-label]="'Editar filial ' + filial.name"
                  [title]="'Editar filial ' + filial.name"
                  (click)="onEditarFilial(filial.id)"
                >
                  <lucide-icon name="pencil" [size]="18"></lucide-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<app-no-results-found [condition]="filiais.length === 0"></app-no-results-found>
<div class="flex justify-end mb-5">
  <app-paginacao
    [numeroDeItens]="dadosPaginacao.itensTotal"
    [tamanhoDaPagina]="dadosPaginacao.tamanhoPagina"
    [paginaSelecionada]="dadosPaginacao.paginaSelecionada"
    [totalPage]="dadosPaginacao.totalPaginas"
    (mudouPagina)="mudouPagina.emit($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
  ></app-paginacao>
</div>
